export const PKG_NAME = "@hpcc-js/codemirror";
export const PKG_VERSION = "3.10.0";
export const BUILD_VERSION = "3.35.0";
